"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoToTs1Banner = GoToTs1Banner;
const snap_ui_1 = require("@teamsnap/snap-ui");
const constants_1 = require("core/constants");
const React = __importStar(require("react"));
function GoToTs1Banner({ ctaUrl, ctaText, }) {
    const highlight = 'TeamSnap ONE Dashboard';
    const textParts = ctaText.split(highlight);
    return (React.createElement("div", { "data-testid": "go-to-ts1-banner", className: "sui-w-full sui-mb-3 sui-mt-0.5 sui-flex sui-bg-white sui-border-solid sui-border sui-border-neutral-border", style: { borderRadius: '8px', height: '60px' } },
        React.createElement("img", { src: constants_1.TS1_LOGO_URL, alt: "TeamSnap ONE Logo", className: "sui-ml-2 sui-p-2" }),
        React.createElement("div", { className: "sui-mx-2 sui-w-[1px] sui-border-l sui-border-neutral-border sui-border-solid sui-h-[60px]" }),
        React.createElement("div", { className: "sui-flex sui-justify-between sui-pl-2 sui-pr-1 sui-py-2 sui-items-center" },
            React.createElement("p", { className: "sui-mb-0 sui-caption" }, textParts.map((part, i) => (React.createElement(React.Fragment, { key: i },
                i > 0 && React.createElement("strong", null, highlight),
                part)))),
            React.createElement(snap_ui_1.LabelButton, { variantType: "primary", "data-testid": "go-to-ts1-button", className: "sui-text-white sui-py-1 sui-ml-4", style: { borderRadius: '4px', backgroundColor: '#0D52BA' }, size: "small", labelText: "Go to TeamSnap ONE", onClick: () => window.open(ctaUrl, '_blank', 'noopener,noreferrer') }))));
}
